function moveFooterIfWideScreen() {
  if ( !document.querySelector( '.e-stn--sticky-top' ) ) return;

  const footer = document.querySelector( 'footer' );
  const container = document.querySelector( '.entry-content' );

  if ( !footer || !container ) return;

  const screenWidth = window.innerWidth;

  if ( screenWidth > 1200 ) {
    if ( !container.contains( footer ) ) {
      container.appendChild( footer );
    }
  }
}

// Run on load and resize
window.addEventListener( 'load', moveFooterIfWideScreen );
window.addEventListener( 'resize', moveFooterIfWideScreen );

  